import { render, staticRenderFns } from "./StudentsWithNoModules.vue?vue&type=template&id=bfbbdd80"
import script from "./StudentsWithNoModules.vue?vue&type=script&lang=js"
export * from "./StudentsWithNoModules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports